import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';

const stats = [
  { value: '5000+', label: '漫画资源', icon: 'ri-bookmark-line' },
  { value: '1200万+', label: '月活用户', icon: 'ri-user-heart-line' },
  { value: '99.7%', label: '用户好评率', icon: 'ri-thumb-up-line' },
  { value: '8大', label: '漫画分类', icon: 'ri-grid-line' },
];

const testimonials = [
  {
    name: '小明同学',
    avatar: '明',
    role: '忠实读者',
    content: '星球漫画真的是我每天必刷的网站！资源超级全，而且完全免费，不用注册就能看，太良心了。下拉式阅读体验也很棒，一口气能看完整部漫画！',
    rating: 5,
  },
  {
    name: '漫画爱好者小王',
    avatar: '王',
    role: '资深漫迷',
    content: '作为一个看了十几年漫画的老漫迷，星球漫画的资源丰富度让我非常惊喜。很多冷门作品都能在这里找到，更新速度也很快，五星推荐！',
    rating: 5,
  },
  {
    name: '追更小能手',
    avatar: '追',
    role: '活跃用户',
    content: '最喜欢星球漫画的更新提醒功能，再也不会错过喜欢的漫画更新了。界面简洁清爽，没有乱七八糟的广告，阅读体验满分！已经推荐给身边所有喜欢看漫画的朋友了。',
    rating: 5,
  },
  {
    name: '深夜漫画党',
    avatar: '夜',
    role: '三年老用户',
    content: '从大学开始就在星球漫画看漫画，现在工作三年了还在用。看着平台一步步成长，资源越来越丰富，真的很开心。希望能一直做下去，我会一直支持的！',
    rating: 5,
  },
];

export default function AboutPage() {
  const pageTitle = '关于星球漫画 - 免费漫画全集在线免费阅读平台';
  const pageDescription = '星球漫画是领先的免费漫画全集在线阅读平台，提供下拉式阅读体验。品牌介绍、用户口碑评价、联系方式。了解我们如何为漫画爱好者提供海量免费漫画资源。';
  const pageKeywords = '星球漫画,免费漫画,关于我们,漫画平台,漫画品牌介绍,漫画网站推荐,免费阅读';

  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于星球漫画',
    description: pageDescription,
    url: 'https://www.xingqiumanhua.com/about',
    isPartOf: {
      '@type': 'WebSite',
      name: '星球漫画',
      url: 'https://www.xingqiumanhua.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutJsonLd) }}
      />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />
      <link rel="canonical" href="https://www.xingqiumanhua.com/about" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:url" content="https://www.xingqiumanhua.com/about" />
      <Navbar />
      <main className="min-h-screen pt-16">
        <div className="max-w-5xl mx-auto">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />

          <div className="px-4 md:px-6">
            {/* Hero */}
            <section className="py-10 md:py-14 text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-500">
                <i className="ri-planet-line text-background-50 text-3xl md:text-4xl"></i>
              </div>
              <h1 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
                关于星球漫画
              </h1>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                星球漫画是一个致力于为广大漫画爱好者提供高质量、免费漫画阅读体验的在线平台。
                我们相信，好的漫画应该被更多人看到，而不应该被付费墙所阻隔。
              </p>
            </section>

            {/* Stats */}
            <section className="py-8 md:py-10">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {stats.map((stat) => (
                  <div key={stat.label} className="bg-background-100 rounded-lg p-5 md:p-6 text-center border border-background-200/70">
                    <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                      <i className={`${stat.icon} text-lg`}></i>
                    </div>
                    <div className="text-xl md:text-2xl font-heading text-foreground-900">{stat.value}</div>
                    <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </section>

            {/* Brand Story */}
            <section className="py-8 md:py-10">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6 text-center">
                <i className="ri-book-read-line text-primary-500 mr-2"></i>
                品牌故事
              </h2>
              <div className="bg-background-100 rounded-lg p-6 md:p-8 border border-background-200/70 max-w-3xl mx-auto">
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  星球漫画诞生于一群漫画爱好者对优质阅读体验的共同追求。我们发现，虽然市面上有很多漫画平台，但大多数都需要付费订阅或者充斥着大量广告，严重影响了读者的阅读体验。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
                  于是，我们决定打造一个真正以读者为中心的免费漫画平台。经过两年多的精心打磨，星球漫画终于与大家见面了。我们采用了先进的下拉式阅读技术，让读者可以像刷社交媒体一样流畅地阅读漫画，无需翻页，一气呵成。
                </p>
                <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                  从最初的几百部漫画，到如今超过5000部作品的海量资源库，星球漫画的每一步成长都离不开广大漫画爱好者的支持与信任。我们将继续努力，为大家带来更多优质的漫画内容和更好的阅读体验。
                </p>
              </div>
            </section>

            {/* Reputation */}
            <section id="reputation" className="py-8 md:py-10">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6 text-center">
                <i className="ri-chat-heart-line text-primary-500 mr-2"></i>
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {testimonials.map((testimonial) => (
                  <div key={testimonial.name} className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70">
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 font-heading text-sm">
                        {testimonial.avatar}
                      </div>
                      <div>
                        <div className="text-sm font-medium text-foreground-900">{testimonial.name}</div>
                        <div className="text-xs text-foreground-500">{testimonial.role}</div>
                      </div>
                      <div className="ml-auto flex items-center gap-0.5">
                        {Array.from({ length: testimonial.rating }).map((_, i) => (
                          <i key={i} className="ri-star-fill text-primary-500 text-sm"></i>
                        ))}
                      </div>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      "{testimonial.content}"
                    </p>
                  </div>
                ))}
              </div>
            </section>

            {/* Contact */}
            <section id="contact" className="py-8 md:py-10">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6 text-center">
                <i className="ri-mail-send-line text-primary-500 mr-2"></i>
                联系我们
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
                <div className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <h4 className="font-heading text-sm text-foreground-900 mb-1">电子邮箱</h4>
                  <p className="text-xs text-foreground-500">contact@xingqiumanhua.com</p>
                </div>
                <div className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-wechat-line text-lg"></i>
                  </div>
                  <h4 className="font-heading text-sm text-foreground-900 mb-1">微信公众号</h4>
                  <p className="text-xs text-foreground-500">星球漫画官方</p>
                </div>
                <div className="bg-background-100 rounded-lg p-5 md:p-6 border border-background-200/70 text-center">
                  <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-question-answer-line text-lg"></i>
                  </div>
                  <h4 className="font-heading text-sm text-foreground-900 mb-1">反馈建议</h4>
                  <p className="text-xs text-foreground-500">在公众号留言反馈</p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}